import { render } from "./SearchedMovies.vue?vue&type=template&id=a461fc42"
import script from "./SearchedMovies.vue?vue&type=script&lang=js"
export * from "./SearchedMovies.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\naska\\Desktop\\Javascript Portfolio Projects\\movie-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__